import React from "react";
import styles from "./FromComponent.module.css";
import { useAuth } from "../../context/Auth";

const RadioButtonGroup = ({
  options,
  selectedOption,
  onChange,
  name,
  fontSize,
  gap,
}) => {
  const { mode } = useAuth();

  const handleStatusChange = (option) => {
    if (onChange) {
      onChange(option);
    }
  };

  return (
    <div className={styles.radioGroup} style={{ gap: gap && gap }}>
      {options.map((option) => (
        <label key={option.value} className={styles.radioItem}>
          <input
            type="radio"
            name={name}
            value={option.value}
            checked={selectedOption === option.value}
            onChange={() => handleStatusChange(option.value)}
            className={styles.radioInput}
          />
          <div className={styles.radioCircle}></div>
          <span
            className={styles.radioLabel}
            style={{
              color: mode ? "#ffffff" : "#646B88",
              fontSize: fontSize && fontSize,
            }}
          >
            {option.label}
          </span>
        </label>
      ))}
    </div>
  );
};

export default RadioButtonGroup;
